import { displayToast } from "../utils/displayToast";

export function useErrorHandler() {
  function handleErrorResponse(error) {
    const rawMessage =
      (typeof error === "string"
        ? error
        : error && typeof error === "object" && "description" in error
        ? error.description
        : "") || "";

    const normalized = rawMessage.toString().trim().toLowerCase();

    if (
      normalized.includes("token expired") ||
      normalized.includes("invalid token")
    ) {
      displayToast("Session expired. Please re-login.");
      try {
        localStorage.removeItem("session");
        localStorage.removeItem("auth_token");
      } catch {
      }
      window.location.href = "/login";
      return;
    }

    displayToast(rawMessage || "An unexpected error occurred.");
  }

  return { handleErrorResponse };
}
